import * as Neb from "nebulas" ;
import * as NebPay from 'nebpay';

const contractAddress = 'n1eXd2qmQdrPgiemBiJ95abXpyJSVfYmFYr';

// Contract addresses

// MAINNET
// TXN: ff00f7d550d80dab8c38bfc998f7f546c14596c81f8b7f60e5fc9619089ee262
// ALPHA_v0.1 - n1eXd2qmQdrPgiemBiJ95abXpyJSVfYmFYr

// TESTNET
// Mostly unusable ...

const nebPay = new NebPay();
const neb = new Neb.Neb();
const api = neb.api;

// Endpoints
// Mainnet: https://mainnet.nebulas.io
// Testnet: https://testnet.nebulas.io
// Local: http://localhost:8685

neb.setRequest(new Neb.HttpRequest("https://mainnet.nebulas.io"));

export { contractAddress, neb, nebPay, api };


// WEBPACK FOOTER //
// ./src/util/nebulas.js